if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer') && this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      var error = false
      console.log("SUBMIT")
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            error = true
            this.handleErrorMessage(response.description);


            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          error = true
          console.error(e);
        })
        .finally(() => {
          console.log("FINAL")
          if (error !== true) {


            var flyout = document.getElementById('cart-flyout');
            var flyout_menu = document.getElementById('cart-flyout-menu');
            const header = document.querySelector('.main-header');

            header.classList.add('is_store_open');

            if (flyout.style.visibility === "hidden") {
              flyout.style.visibility = "visible";
            } else {
              flyout.style.visibility = "hidden";
            }
            if (flyout.style.opacity === "0") {
              flyout.style.opacity = "1"
            } else {
              flyout.style.opacity = "0";
            }
            if (flyout_menu.style.right === "-1080px") {
              flyout_menu.style.right = "0"
            } else {
              flyout_menu.style.right = "-1080px";
            }
          }

          this.submitButton.classList.remove('loading');
          // if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          const changeButtonsMain = [...document.querySelectorAll('.main-ChangeOption'), ...document.querySelectorAll('.changeOption')]
          changeButtonsMain.forEach((button) => {
            button.addEventListener('click', (e) => {
              const parent = e.target.parentElement
              if (parent) {
                parent.querySelector('.product-options__wrapper').style.display = 'flex'
                e.target.style.display = "none"
              }
            })
          })
          const cancelButtonsMain = [...document.querySelectorAll('.main-cancelOption'), ...document.querySelectorAll('.cancelOption')]
          cancelButtonsMain.forEach((button) => {
            button.addEventListener('click', (e) => {
              const parent = e.target.parentElement.parentElement
              if (parent) {
                parent.querySelector('.product-options__wrapper').style.display = 'none'
                parent.querySelector('.main-ChangeOption').style.display = "inherit"
              }
            })
          })


        });

    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
